import { AxiosError } from "axios";
import { useState } from "react";

import {
  QUOTE_JOURNEY_TYPE,
  QUOTE_CHANNEL_ONLINE,
} from "@/config/app-constant";
import { Routes } from "@/config/page-view-constants";
import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import logError from "@/utils/logger";

interface AddMedicalProps {
  referenceId?: string;
  version?: string;
}

export default function useMedicalTerms() {
  const [medData, setMedicalResponse] = useState(null);
  const [medLoading, setLoading] = useState<boolean>(false);
  const [medError, setError] = useState<null | AxiosError>(null);

  const patchMedicalTerms = async ({
    referenceId,
    version,
  }: AddMedicalProps) => {
    const url = `${process.env.NEXT_PUBLIC_BASE_URL}/quote/${referenceId}/updateMedicalTermsAndCondition`;
    const postBody = {
      data: {
        type: QUOTE_JOURNEY_TYPE,
        channel: QUOTE_CHANNEL_ONLINE,
        version,
        viewPage: Routes.TravellerHealth,
        attributes: {
          domain: PRODUCT_DOMAIN,
          travellerDetails: {
            medicalTermsAndConditions: true,
          },
        },
      },
    };

    try {
      setLoading(true);
      const response = await axioInstance.patch(url, postBody);

      setMedicalResponse(response.data);
    } catch (err) {
      const axioErr = err as AxiosError;
      setError(axioErr);
      logError(axioErr, { location: "Traveller health page submit" });
    } finally {
      setLoading(false);
    }
  };

  return { patchMedicalTerms, medData, medLoading, medError };
}
